module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/regenerator/index.js
 ** module id = 587
 ** module chunks = 0
 **/